import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { ACORNS_DISCLOSURES_URL } from 'app-constants'
import { TestIDs } from 'test/utils/testIds'
import themevalues from 'theme'

import { PreviewPortfolioContainer } from '../styled-components'
import {
  ProjectionContainerDisclaimer,
  ProjectionContainerHeading,
  ProjectionDisclaimerLink,
  StatsColumnPercentage,
  StatsColumnTitle,
  StatsContainer,
  StatsContainerColumn,
  StatsContainerDivider,
  StatsPercentIcon,
  StatsPercentIconContainer,
} from './styled-components'

type Props = {
  lowProjection: number
  highProjection: number
  averageProjection: number
}

const YearProjectionOverview = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()
  return (
    <PreviewPortfolioContainer>
      <ProjectionContainerHeading data-testid={TestIDs.PREVIEW_PORTFOLIO.PROJECTION_TITLE}>
        {getRemoteString({
          key: 'portfolio.year_projection_overview.title',
        })}
      </ProjectionContainerHeading>
      <StatsContainer>
        <StatsContainerColumn>
          <StatsColumnTitle>
            {getRemoteString({
              key: 'portfolio.year_projection_overview.low',
            })}
          </StatsColumnTitle>
          <StatsPercentIconContainer>
            <StatsPercentIcon icon={AcornsIcon.Icon.ArrowDown} width="10px" height="13px" />
            <StatsColumnPercentage>{props.lowProjection?.toFixed(1) + '%'}</StatsColumnPercentage>
          </StatsPercentIconContainer>
        </StatsContainerColumn>
        <StatsContainerDivider />
        <StatsContainerColumn>
          <StatsColumnTitle>
            {getRemoteString({
              key: 'portfolio.year_projection_overview.high',
            })}
          </StatsColumnTitle>
          <StatsPercentIconContainer>
            <StatsPercentIcon icon={AcornsIcon.Icon.ArrowUp} width="10px" height="13px" />
            <StatsColumnPercentage>{props.highProjection?.toFixed(1) + '%'}</StatsColumnPercentage>
          </StatsPercentIconContainer>
        </StatsContainerColumn>
        <StatsContainerDivider />
        <StatsContainerColumn>
          <StatsColumnTitle color={themevalues.colors.purple} isBold={true}>
            {getRemoteString({
              key: 'portfolio.year_projection_overview.average',
            })}
          </StatsColumnTitle>
          <StatsPercentIconContainer>
            <StatsPercentIcon icon={AcornsIcon.Icon.ArrowUp} width="10px" height="13px" />
            <StatsColumnPercentage>
              {props.averageProjection?.toFixed(1) + '%'}
            </StatsColumnPercentage>
          </StatsPercentIconContainer>
        </StatsContainerColumn>
      </StatsContainer>
      <ProjectionContainerDisclaimer>
        {getRemoteString({
          key: 'portfolio.year_projection_overview.disclaimer',
        })}{' '}
        <ProjectionDisclaimerLink
          href={ACORNS_DISCLOSURES_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Important Disclosures.
        </ProjectionDisclaimerLink>
      </ProjectionContainerDisclaimer>
    </PreviewPortfolioContainer>
  )
}

export default YearProjectionOverview
